// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"successful-allianz-process_modal-content_2oSxj"};